import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ScopeProvider, useScope } from '../components/ScopeProvider';
import ScopeSelector from '../components/ScopeSelector';
import MetasConfig from './MetasConfig';
import PromptEditor from './PromptEditor';
import WhitelabelConfig from './WhitelabelConfig';
import Comunicados from './Comunicados';
import TetosConfig from './TetosConfig';
import './Configuracoes.css';

/**
 * Configurações — o único lugar de configuração (§9.1/§9.3).
 *
 * O PRINCÍPIO: existe UM lugar para configurar, e o escopo é um seletor. A primeira entrada do
 * seletor é o padrão da empresa (ongoing); as seguintes são as lojas e as fases. Antes disso, a
 * mesma coisa era configurada em menus diferentes e o par Empresa+Loja era refeito em cada tela.
 *
 * AS ABAS HOSPEDAM AS TELAS QUE JÁ EXISTEM, e isso é deliberado: elas passam a ler o escopo
 * compartilhado em vez de manter o próprio par de selects, e todo o resto do comportamento
 * continua sendo o mesmo código. Reescrever as telas daria paridade só na aparência — o
 * PromptEditor tem 2.381 linhas com cinco painéis embutidos, e o que se perderia numa reescrita
 * é justamente o que ninguém lembra de listar.
 *
 * As abas entram uma por vez, e o item antigo do menu é escondido **quando** a aba equivalente
 * existe — nunca antes, para não deixar o CS sem caminho, e nunca depois, para não haver dois
 * caminhos para a mesma coisa.
 */

const ABAS = [
    { key: 'prompts', label: 'Prompts e Pontuação', Componente: PromptEditor },
    { key: 'metas', label: 'Metas', Componente: MetasConfig },
    { key: 'tetos', label: 'Tetos', Componente: TetosConfig },
    { key: 'whitelabel', label: 'Whitelabel', Componente: WhitelabelConfig },
    { key: 'comunicados', label: 'Comunicados', Componente: Comunicados },
];

function ConteudoAba({ aba, user }) {
    const escopo = useScope();
    const def = ABAS.find((a) => a.key === aba) || ABAS[0];
    const { Componente } = def;
    return (
        <>
            <ScopeSelector />
            {!escopo.subdomain ? (
                <p className="cfg-vazio">Selecione uma empresa para configurar.</p>
            ) : (
                <Componente user={user} scope={escopo.scope} />
            )}
        </>
    );
}

function Configuracoes({ user }) {
    const { aba } = useParams();
    const navigate = useNavigate();
    const atual = ABAS.find((a) => a.key === aba) ? aba : ABAS[0].key;

    return (
        <div className="cfg-page">
            <header className="cfg-header">
                <h1>Configurações</h1>
                <p className="cfg-sub">
                    Escolha o escopo uma vez: ele vale para todas as abas. Fase sobrescreve loja, que
                    sobrescreve o padrão da empresa.
                </p>
            </header>

            <nav className="cfg-abas">
                {ABAS.map((a) => (
                    <button
                        key={a.key}
                        className={`cfg-aba ${a.key === atual ? 'cfg-aba-ativa' : ''}`}
                        onClick={() => navigate(`/config/${a.key}`)}
                    >
                        {a.label}
                    </button>
                ))}
            </nav>

            <ScopeProvider>
                <ConteudoAba aba={atual} user={user} />
            </ScopeProvider>
        </div>
    );
}

export default Configuracoes;
